<template>
  <div class="text-wrapper" ref="wrapper">
    <div class="moving-words">
      <div class="words" ref="words"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    const self = this
    self.$eventBus.$on('PAGE_LOADED', () => {
      const movingWords = self.$refs.words
      movingWords.innerHTML = movingWords.textContent.replace(/[\u0600-\u06FF]+/g, "<span class='word'><span class='word__inner'>$&</span></span>")

      self.$anime.timeline({ loop: false })
        .add({
          loop: false,
          targets: '.word__inner',
          scale: { value: [0, 1], delay: self.$anime.stagger(200)/* , duration: 2000  */ },
          translateY: ['-1.1em', 0],
          translateX: ['-0.55em', 0],
          translateZ: 0,
          rotateZ: { value: [90, 0]/* , duration: 500 */ },
          // duration: 750,
          easing: 'easeInOutExpo',
          delay: self.$anime.stagger(200)
        })/* .add({
        targets: self.$refs.wrapper,
        opacity: 0,
        duration: 1000,
        easing: 'easeOutExpo',
        delay: 1000
      }) */ })
  }
}
</script>

<style lang="scss">
.text-wrapper {
  position: relative;

  .moving-words {
    position: relative;
    display: inline-block;
    padding-top: 0.2em;
    padding-right: 0.05em;
    padding-bottom: 0.1em;
    overflow: hidden;
  }

  .words {
    line-height: 1.2;
  }

  .word {
    display: inline-block;
    line-height: 1.5;
    overflow: hidden;

    .word__inner {
      transform-origin: 100% 100%;
      display: inline-block;
    }
  }
}
</style>
